import React, { useState, useEffect } from 'react'
import './pricingTable.css'
import PayButton from '../../pages/PayButton'
import axios from 'axios'
import key from '../../key'

const discount = (price, discount) => {
    return price - (price * discount / 100)
}
const PricingTable = () => {
    const [data, setData] = useState()
    useEffect(() => {
        const getData = async () => {
            try {
                const res = await axios.get(`${key}/api/admin/get-subscription`)
                setData(res.data.subscriptions)
            } catch (err) {
                console.log(err)
            }
        }
        getData()
        //eslint-disable-next-line
    }, [data])

    // const item = {
    //     _id: "649abc6d3e1fa21b9a267044",
    //     subscription: "Silver Lovodi",
    //     price: 20,
    //     discount: 10,
    //     unlimitedMsg: true,
    //     likes: 45,
    //     sendInterests: 100,
    // }

    return (
        <div className="pricing pricing-palden">
            {
                data?.map((item, index) => {
                    return (
                        <div key={index} className={index === 1 ? `pricing-item pricing__item--featured` : `pricing-item `}>
                            {index === 1 && <div className="best-value">Best Value</div>}
                            <div className="pricing-deco">
                                <svg
                                    className="pricing-deco-img"
                                    enableBackground="new 0 0 300 100"
                                    height="100px"
                                    id="Layer_1"
                                    preserveAspectRatio="none"
                                    version="1.1"
                                    viewBox="0 0 300 100"
                                    width="300px"
                                    x="0px"
                                    xmlSpace="preserve"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    xmlns="http://www.w3.org/2000/svg"
                                    y="0px"
                                >
                                    <path
                                        className="deco-layer deco-layer--1"
                                        d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
	c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"
                                        fill="#FFFFFF"
                                        opacity="0.6"
                                    ></path>
                                    <path
                                        className="deco-layer deco-layer--2"
                                        d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
	c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"
                                        fill="#FFFFFF"
                                        opacity="0.6"
                                    ></path>
                                    <path
                                        className="deco-layer deco-layer--3"
                                        d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
	H42.401L43.415,98.342z"
                                        fill="#FFFFFF"
                                        opacity="0.7"
                                    ></path>
                                    <path
                                        className="deco-layer deco-layer--4"
                                        d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
	c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"
                                        fill="#FFFFFF"
                                    ></path>
                                </svg>
                                <div className='price'>
                                    <div className='discount'>{item.discount}% off
                                        <span>USD {item.price}</span>
                                    </div>
                                    <div className="pricing-price"><span className="pricing-currency">USD</span>{discount(item.price, item.discount)}
                                        <span className="pricing-period">{item?.validity}</span>
                                    </div>
                                </div>
                                <h3 className="pricing-title">{item.subscription}</h3>
                            </div>
                            <ul className="pricing-feature-list">
                                <li className="pricing-feature">Send Unlimited Messages: <span>{item.unlimitedMsg === 'true' ? "Yes" : "No"}</span></li>
                                <li className="pricing-feature">View Phones of Mutual Likes: <span>{item.likes}</span></li>
                                <li className="pricing-feature">How many Contact You can View: <span>{item.viewContacts}</span></li>
                            </ul>
                            <PayButton data={item} />
                        </div>

                    )
                })
            }

        </div>
    )
}

export default PricingTable
